import { setFulfilled, setPending, setRejected } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { AllAdminsLoadAction } from '../../domains/allAdmins/actions.types';

import { AllAdmins } from './types';
const initialState: AllAdmins = {
  pending: false,
  fulfilled: undefined,
  rejected: undefined,
};

const reducer: Reducer<AllAdmins, AllAdminsLoadAction> = (state = initialState, action: AllAdminsLoadAction) => {
  switch (action.type) {
    case 'ALL_ADMINS.LOAD_FULFILLED':
      return setFulfilled({
        [action?.payload?.after === '' ? 0 : action.payload.after]: action.payload.entities.sortedAdmins,
      });
    case 'ALL_ADMINS.LOAD_PENDING':
      return setPending();
    case 'ALL_ADMINS.LOAD_REJECTED':
      return setRejected(action.payload.error);
    default:
      return state;
  }
};

export default reducer;
